import axios from "axios";
import { useFormik } from "formik";
import { Toaster, toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { BlogAddCategorySchema } from "../../../ValidationSchema";
import { useState } from "react";

const BlogCategoryAdd = () => {
  const Navigate = useNavigate();

  // ✅ Direct static initial values (not via useState)
  const initialValues = {
    name: "",
  };

  const [isSubmitting, setIsSubmitting] = useState(false);

  const formik = useFormik({
    initialValues,
    validationSchema: BlogAddCategorySchema,
    onSubmit: async (values, actions) => {
      if (isSubmitting) return; // ✅ prevents double submit
      setIsSubmitting(true);

      try {
        const res = await axios.post(
          `${process.env.REACT_APP_URL}/admin/blog/category`,
          { name: values.name },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("Token")}`,
            },
          }
        );

        toast.success(res?.data?.message || "Category added successfully!");
        actions.resetForm();
        Navigate("/admin/blog-category", { state: res?.data?.message });
      } catch (err) {
        toast.error(err?.response?.data?.message || "Something went wrong");
      } finally {
        setIsSubmitting(false);
      }
    },
  });

  return (
    <div className="al">
      <Toaster position="top-center" reverseOrder={false} />

      <div className="al-head">
        <div>
          <h1 className="al-title">Add Blog Category</h1>
          <p className="al-sub">Create a new blog category.</p>
        </div>
        <div className="al-head__actions">
          <button type="button" className="al-btn" onClick={() => Navigate(-1)}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
            Back
          </button>
        </div>
      </div>

      <form onSubmit={formik.handleSubmit}>
        <div className="al-card">
          <div className="al-cardhead">
            <div className="al-cardhead__icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.59 13.41 13.42 20.6a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" /><line x1="7" y1="7" x2="7.01" y2="7" /></svg></div>
            <h3 className="al-cardhead__title">Blog Category Details</h3>
          </div>

          <div className="al-form">
            <div className="al-form__full">
              <label className="al-label">Name <span className="al-req">*</span></label>
              <input className="al-input" type="text" placeholder="Enter Category Name"
                name="name"
                value={formik.values.name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur} />
              {formik.touched.name && formik.errors.name && (
                <div className="al-err">{formik.errors.name}</div>
              )}
            </div>
          </div>

          <div className="al-actionbar">
            <button type="button" className="al-btn" onClick={() => Navigate(-1)}>Cancel</button>
            <button type="submit" className="al-btn al-btn--primary" disabled={formik.isSubmitting}>
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
              {formik.isSubmitting ? "Submitting..." : "Create Category"}
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default BlogCategoryAdd;
